// Don't close Menu Dropdowns on click outside in sidebar menu
(function init_sidebar_menu_js($) {
    $('.navbar--sidebar').on('hide.bs.dropdown', function (e) {
        if (e.clickEvent) {
            e.preventDefault();
        }
    });
})(jQuery);
